import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLOR, RADIUS, SHADOW } from './tokens';

/** Surface panel with an optional title row (icon, title, action). */
export default function Card({ title, icon = null, action = null, children, padded = true, sx, ...rest }) {
    return (
        <Box
            sx={[
                {
                    bgcolor: COLOR.surface,
                    border: `1px solid ${COLOR.border}`,
                    borderRadius: RADIUS.lg,
                    boxShadow: SHADOW[1],
                    overflow: 'hidden',
                    color: COLOR.text,
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...rest}
        >
            {title ? (
                <Box
                    sx={{
                        px: 2,
                        py: 1.5,
                        borderBottom: `1px solid ${COLOR.border}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 1,
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                        {icon}
                        <Typography component="h2" sx={{ fontSize: '1.125rem', fontWeight: 700, color: COLOR.text }}>
                            {title}
                        </Typography>
                    </Box>
                    {action}
                </Box>
            ) : null}
            {padded ? <Box sx={{ p: 2 }}>{children}</Box> : children}
        </Box>
    );
}
